import { render, staticRenderFns } from "./ImgixImage.vue?vue&type=template&id=4a082d9e&"
import script from "./ImgixImage.vue?vue&type=script&lang=js&"
export * from "./ImgixImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports